import { GenericLink, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { formatDate } from '@commerce-search-webcomponents/sdk';
import { ContentCardProps, ModeEnum, VariantEnum } from './types/propTypes';
import styles from './ContentCard.module.scss';
const ContentCard = ({
  description,
  mode = ModeEnum.ARTICLE,
  tag,
  title,
  link,
  promotionDate,
  imageUrl,
  variant = VariantEnum.SRP,
  readMinutes,
  backgroundColor,
  textColor,
}: ContentCardProps) => {
  const imageUrlTrimed = imageUrl?.trim();
  const imageWidth = variant === VariantEnum.SRP ? 450 : 200;
  const imageUrlReSized = `${imageUrlTrimed}?width=${imageWidth}`;
  const variantClass = variant === VariantEnum.SRP ? styles.searchPage : styles.searchOverlay;
  const modeClass = mode === ModeEnum.ARTICLE ? styles.article : styles.offers;

  const getPromotionDate = () => {
    if (promotionDate) {
      const dateRegex = /\b\d{1,2} \w{1,12} \d{4}\b/;
      const match = promotionDate.match(dateRegex);
      return match && <span className={styles.date}>{formatDate(match[0]?.trim())}</span>;
    }
    return null;
  };
  let highlightStyle = {};
  if (backgroundColor) {
    highlightStyle = {
      ...highlightStyle,
      backgroundColor,
    };
  }
  if (textColor) {
    highlightStyle = {
      ...highlightStyle,
      color: textColor,
    };
  }
  return (
    <div
      data-testid="content-card"
      className={`${styles.contentCard} ${variantClass} ${modeClass} content-card`}
      style={{ ...highlightStyle }}
    >
      <GenericLink href={link}>
        <div className={`${styles.cardContainer}`}>
          {imageUrlTrimed && (
            <div className={styles.thumbnailContainer}>
              <img src={imageUrlReSized} alt={title} className="content-image" />
            </div>
          )}
          {!imageUrlTrimed && (
            <div className={`${styles.thumbnailContainer} ${styles.noImageContainer} no-image-container`}>
              <div className={`${styles.noImage} ${mode === ModeEnum.OFFER && styles.offerWidth}`}>
                <NextgenImage
                  loaderType={LoaderType.WEBFONTS}
                  isRelativeURL
                  alt={title}
                  src={`/icons/AmwayWhiteNoBorder.svg`}
                />
              </div>
            </div>
          )}
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.tag}>{tag}</div>
              <div className={`${styles.title} ${mode === ModeEnum.ARTICLE && styles.lessHeight}`}>{title}</div>
              {description && variant === VariantEnum.SRP && mode === ModeEnum.ARTICLE && (
                <div className={styles.details}>{description}</div>
              )}
            </div>

            <div className={styles.cardFooter}>
              {mode === ModeEnum.OFFER && (
                <>
                  <span className={styles.public}>Public</span>
                  {!!promotionDate && <span className={styles.dot}>·</span>}
                  {getPromotionDate()}
                </>
              )}
              {mode === ModeEnum.ARTICLE && (
                <>
                  {!!readMinutes && variant === VariantEnum.SRP && (
                    <span className={styles.readMinutes}>{readMinutes}</span>
                  )}
                  {!!readMinutes && variant === VariantEnum.SRP && !!promotionDate && (
                    <div className={styles.divider}></div>
                  )}
                  {getPromotionDate()}
                </>
              )}
            </div>
          </div>
        </div>
      </GenericLink>
    </div>
  );
};

export default ContentCard;
export type { ContentCardProps };
export { ModeEnum, VariantEnum };
